<template>
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <el-drawer :visible.sync="visible"
    :title="title"
    :wrapperClosable="true"
    :before-close="handleClose"
    @open="handleDrawerOpen"
    @close="handleDrawerClose"
    size="78%"
  >
    <div class="container">
      <header class="container-header">
        <div class="container-header-title">基础信息</div>
        <div class="container-header-form">
          <el-form label-width="100px" ref="nameForm" :model="nameForm">
            <el-row>
              <el-col :span="12">
                <span v-if="isStatic">{{ nameForm.name }}</span>
                <el-form-item
                  v-else
                  label="角色名称"
                  prop="name"
                  :rules="[{
                    required: true,
                    message: '请输入角色名称',
                    trigger: 'blur',
                  }]"
                >
                  <el-input
                    v-model="nameForm.name"
                    placeholder="请输入"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </header>
      <section class="container-section">
        <header class="container-section-header">
          <div class="container-section-header-title">页面权限配置</div>
          <div class="container-header-form">
            <el-input
              v-model="filterText"
              placeholder="搜索字段、资源"
              prefix-icon="el-icon-search"
            />
          </div>
        </header>
        <main class="container-section-main">
          <aside class="container-section-main-aside">
            <div class="container-section-main-aside-typetitle">统一脱敏回显控制</div>
              <el-tree
                :data="privacyTree"
                show-checkbox
                default-expand-all
                check-strictly
                :default-checked-keys="defaultCheckedKeys"
                :default-expanded-keys="defaultExpandedKeys"
                :filter-node-method="filterNode"
                node-key="id"
                highlight-current
                ref="vehiclePrivacyTree"
                :props="defaultProps"
                @node-click="handleTreeNodeClick"
                @check="handleTreeNodeCheck"
              >
                <span slot-scope="{ node }" class="custom-tree-node">
                  <el-tooltip :content="node.label" placement="right">
                    <FilteText :filterText="filterText" :label="node.label" />
                  </el-tooltip>
                </span>
              </el-tree>
            <div class="container-section-main-aside-typetitle">PC后台</div>
            <el-tree
              :data="webTree"
              show-checkbox
              default-expand-all
              check-strictly
              :default-checked-keys="defaultCheckedKeys"
              :default-expanded-keys="defaultExpandedKeys"
              :filter-node-method="filterNode"
              node-key="id"
              highlight-current
              ref="vehicleWebTree"
              :props="defaultProps"
              @node-click="handleTreeNodeClick"
              @check="handleTreeNodeCheck"
            >
              <span slot-scope="{ node }" class="custom-tree-node">
                <el-tooltip :content="node.label" placement="right" disabled>
                  <FilteText :filterText="filterText" :label="node.label" />
                </el-tooltip>
              </span>
            </el-tree>
            <div class="container-section-main-aside-typetitle">车管小程序</div>
            <el-tree
              :data="mpTree"
              show-checkbox
              default-expand-all
              check-strictly
              :default-checked-keys="defaultCheckedKeys"
              :default-expanded-keys="defaultExpandedKeys"
              :filter-node-method="filterNode"
              node-key="id"
              highlight-current
              ref="miniProgramTree"
              :props="defaultProps"
              @node-click="handleTreeNodeClick"
              @check="handleTreeNodeCheck"
            >
              <span slot-scope="{ node }" class="custom-tree-node">
                <FilteText :filterText="filterText" :label="node.label" />
              </span>
            </el-tree>
          </aside>
          <div class="container-section-main-div">
            <!-- 页面主体和按钮 -->
            <div v-if="currentNode" class="container-section-main-div-title">
              主页面
            </div>
            <div class="container-section-main-div-item" v-if="currentNode">
              <div class="container-section-main-div-item-title">
                <el-checkbox
                  v-model="currentNode.checked"
                  @change="handleMainCheckboxChange"
                  :disabled="currentNode.disabled || !showCheckbox"
                >
                  <span class="mr-5">
                    <FilteText
                      :filterText="filterText"
                      :label="currentNode.label"
                    />
                    ({{ checkedBtnNum() }}/{{
                      currentNodeBtnList.length
                    }})
                  </span>
                  <el-tooltip
                    v-if="currentNode.remark"
                    effect="dark"
                    :content="currentNode.remark"
                    placement="top-start"
                    class="mlt-4"
                  >
                    <i class="el-icon-warning-outline"></i>
                  </el-tooltip>
                </el-checkbox>
              </div>
              <ul
                class="container-section-main-div-item-ul"
                v-if="currentNodeBtnList.length > 0"
              >
                <li v-for="item in currentNodeBtnList" :key="item.id">
                  <el-checkbox
                    v-model="item.checked"
                    :disabled="item.disabled || !showCheckbox"
                    @change="handleBtnCheckboxChange(item)"
                  >
                    <FilteText :filterText="filterText" :label="item.name"/>
                  </el-checkbox>
                  <el-tooltip
                    v-if="item.remark"
                    effect="dark"
                    :content="item.remark"
                    placement="top-start"
                    class="mlt-4"
                  >
                    <i class="el-icon-warning-outline"></i>
                  </el-tooltip>
                </li>
              </ul>
            </div>

            <!-- 页面关联的子页面 -->
            <div
              v-if="currentNodeSubPage.length > 0"
              class="container-section-main-div-title"
            >
              子页面
            </div>
            <div
              v-for="item in currentNodeSubPage"
              :key="item.id"
              class="container-section-main-div-item"
            >
              <div class="container-section-main-div-item-title">
                <el-checkbox
                  v-model="item.checked"
                  @change="handleCheckboxChange(item)"
                  :disabled="item.disabled || !showCheckbox"
                >
                  <span class="mr-5">
                    <FilteText
                      :filterText="filterText"
                      :label="item.name"
                    />
                    ({{ getSubListCheckedBtn(item.subList) }}/{{
                      item.subList.length
                    }})
                  </span>
                  <el-tooltip
                    v-if="item.remark"
                    effect="dark"
                    :content="item.remark"
                    placement="top-start"
                    class="mlt-4"
                  >
                    <i class="el-icon-warning-outline"></i>
                  </el-tooltip>
                </el-checkbox>
              </div>
              <ul
                class="container-section-main-div-item-ul"
                v-if="item.subList.length > 0"
              >
                <li v-for="cItem in item.subList" :key="cItem.id">
                  <el-checkbox
                    v-model="cItem.checked"
                    :disabled="cItem.disabled || !showCheckbox"
                    @change="handleSubCheckboxChange(item, cItem)"
                  >
                    <span class="mr-5">
                      <FilteText
                        :filterText="filterText"
                        :label="cItem.name" />
                    </span>
                  </el-checkbox>
                  <el-tooltip
                    v-if="cItem.remark"
                    effect="dark"
                    :content="cItem.remark"
                    placement="top-start"
                    class="mlt-4"
                  >
                    <i class="el-icon-warning-outline"></i>
                  </el-tooltip>
                </li>
              </ul>
            </div>
          </div>
        </main>
      </section>
      <footer class="drawer-footer" v-if="!isSysRole">
        <el-button @click="handleClose" v-if="showCheckbox">取消</el-button>
        <el-button type="primary" @click="handleReEdit" :loading="loading">
          {{ btnPrimaryText }}
        </el-button>
      </footer>
    </div>
  </el-drawer>
</template>
<script>
import { cloneDeep, remove } from 'lodash'
import { getResourceByTokenV2 } from '@/api/global'
import {
  addPreRole,
  getPreRoleDetail,
  editPreRole,
} from '@/api/domain/organize.js'
import { MODE_ENUM, TYPE_ENUM } from '../config/role'
import FilteText from './filterText'
import { RESOURCE_TYPE, RESOURCE_PARAMS } from './const'

const MODE_MAPPER = new Map([
  [1, '角色权限详情'],
  [2, '编辑角色'],
  [3, '新建角色'],
  [4, '复制并创建'],
])

// ref引用
const REF_CONF = {
  [RESOURCE_TYPE.WEB]: 'vehicleWebTree',
  [RESOURCE_TYPE.MP]: 'miniProgramTree',
  [RESOURCE_TYPE.PRIVACY]: 'vehiclePrivacyTree',
}

// 0 下发业务超管角色、1所有账号默认可见、2下发目录菜单不可见
const VISIBLE_MAPPER = {
  MANAGE_ROLE: 0, // 管理员可见
  ALL_ROLE: 1, // 管理员可见
  NOT_ROLE: 2, // 管理员可见
}

export default {
  name: 'addAndEditRoleDrawer',
  components: {
    FilteText,
  },
  props: {
    mode: {
      type: Number,
      default: MODE_ENUM.STATIC,
    },
    // 是否是系统角色 系统角色不可编辑
    isSysRole: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modeType: MODE_ENUM.STATIC,
      loading: false,
      currentNode: null,
      nameForm: {
        name: '',
      },
      filterText: '',
      webTree: [],
      mpTree: [],
      privacyTree: [],
      defaultCheckedKeys: [],
      defaultExpandedKeys: [],
      subList: [],
      // 很关键
      subListCheckedKeys: [],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
    }
  },
  computed: {
    btnPrimaryText() {
      if (this.showCheckbox) {
        return '确定'
      }
      return '编辑'
    },
    isStatic() {
      return this.modeType === MODE_ENUM.STATIC
    },
    isCopy() {
      return this.modeType === MODE_ENUM.COPY
    },
    isEdit() {
      return this.modeType === MODE_ENUM.EDIT
    },
    // 当前所在的页面是否被选中 未选中时 右侧内容区域为置灰状态
    currentNodeDisabled() {
      return !this.currentNodeTreeCheckedKeys?.includes(this.currentNode.id)
    },
    currentNodeTreeCheckedKeys() {
      return this.currentNodeRef.getCheckedKeys()
    },
    currentNodeRef() {
      return this.getRef(this.currentNode.businessGroup)
    },
    currentNodeBtnList() {
      if (!this.currentNode) return []

      let btnList = this.currentNode.subList.filter((item) =>
        this.isBtn(item.type))
      btnList = btnList.map((item) => ({
        ...item,
        pid: this.currentNode.id,
        disabled: item.disabled || false,
        checked: this.subListCheckedKeys?.includes(item.id),
      }))

      return btnList
    },
    currentNodeSubPage() {
      if (!this.currentNode) return []
      let subPageList = this.currentNode.subList.filter((item) =>
        this.isSubPage(item.type, this.currentNode.type))

      // 当前树节点 是否为选中状态
      subPageList = subPageList.map((item) => ({
        ...item,
        pid: this.currentNode.id,
        checked: this.subListCheckedKeys?.includes(item.id),
        disabled: this.currentNodeDisabled || !!item?.disabled,
        subList: (item.subList || []).map((v) => {
          return {
            ...v,
            checked: this.subListCheckedKeys?.includes(v.id),
            disabled: this.currentNodeDisabled || !!v?.disabled,
          }
        }),
      }))
      return subPageList
    },
    title() {
      return MODE_MAPPER.get(this.modeType)
    },
    showCheckbox() {
      return this.modeType !== MODE_ENUM.STATIC
    },
  },
  watch: {
    filterText(val) {
      this.$refs.vehicleWebTree.filter(val)
      this.$refs.miniProgramTree.filter(val)
      this.$refs.vehiclePrivacyTree.filter(val)
    },
  },
  methods: {
    handleReEdit() {
      if (this.showCheckbox) {
        this.handleSubmit()
        return
      }
      this.modeType = MODE_ENUM.EDIT
      this.webTree = this.renderTree(cloneDeep(this.web_res.data))
      this.mpTree = this.renderTree(cloneDeep(this.mini_program_res.data))
      this.privacyTree = this.renderTree(cloneDeep(this.privacy_res.data))
      this.refreshCurrentNode()
    },
    checkedBtnNum() {
      return this.currentNodeBtnList.filter((item) => item.checked)?.length || 0
    },
    getSubListCheckedBtn(subList) {
      return subList.filter((item) => item.checked)?.length || 0
    },
    refreshCurrentNode() {
      this.currentNode = cloneDeep(this.currentNode)
      this.$forceUpdate()
    },
    getRef(businessGroup) {
      return this.$refs[REF_CONF[businessGroup]]
    },
    // 右侧展示内容 主页面 checkbox 选中问题
    handleMainCheckboxChange(checked) {
      const { id, subList = [], type } = this.currentNode
      this.currentNodeRef.setChecked(id, checked)
      // checked 选中 将sublist中所有的内容加进去
      // checked 未选中 将sublist中所有的内容加进去
      subList?.forEach((subNode) => {
        this.addOrRemoveKeyInSubListCheckedKeys(checked, subNode.id)
        if (this.isSubPage(subNode.type, type) && subNode?.subList) {
          subNode.subList.forEach((btn) => {
            this.addOrRemoveKeyInSubListCheckedKeys(checked, btn.id)
          })
        }
      })
      this.refreshCurrentNode()
      let allKeys = this.currentNodeRef.getCheckedKeys()

      const setCheckedKeys = [
        ...this.currentNode.subListPageKeys,
        this.currentNode.id,
      ]
      if (checked) {
        allKeys = allKeys.concat(setCheckedKeys)
        this.currentNodeRef.setCheckedKeys(allKeys, true)
      }
      this.deepDeCheckedParent(this.currentNodeRef, checked, this.currentNode)
    },
    addOrRemoveKeyInSubListCheckedKeys(checked, key) {
      // 选中考虑增加
      if (checked && !this.subListCheckedKeys?.includes(key)) {
        this.subListCheckedKeys.push(key)
      }
      // 未选中删除
      if (!checked && this.subListCheckedKeys?.includes(key)) {
        remove(this.subListCheckedKeys, (n) => n === key)
      }
    },
    deepDeCheckedParent(ref, checked, checkedNode) {
      const parentNode = ref.getNode(checkedNode.pid)
      // 如果取消选中 还需要查看 当前上一级菜单 的所有子是否一个都不存在与
      if (!parentNode) return
      const index = parentNode?.childNodes.findIndex((cnode) => cnode.checked)
      // 取消的操作
      if (!checked && parentNode.checked && index === -1) {
        ref.setChecked(checkedNode.pid, checked, false)
      }
      // 增加操作
      if (checked && !parentNode.checked) {
        ref.setChecked(checkedNode.pid, checked, false)
      }
      this.deepDeCheckedParent(ref, checked, parentNode.data)
    },
    /**
     * 左侧树 checkbox被选中/取消时触发
     * 目标只有一个： 将所有的按钮/子页面 放入/删除 subListCheckedKeys
     * 关注点: 因为当前tree执行严格模式 所以当前节点是否选中需要
     * 第一参数 checkedNode 当前节点
     * 第二参数 { checkedKeys, checkedNodes, halfCheckedKeys, halfCheckedNodes}
     * */
    handleTreeNodeCheck(checkedNode, { checkedKeys }) {
      // checkedNode 是否选中状态
      const checked =
        checkedKeys.findIndex((id) => id === checkedNode.id) !== -1
      const ref = this.getRef(checkedNode.businessGroup)
      // 这是 subListPageKeys 所有的子菜单 需要根据当前的状态
      if (this.isDict(checkedNode.type)) {
        let allKeys = ref.getCheckedKeys()
        const setCheckedKeys = [...checkedNode.subListPageKeys, checkedNode.id]
        if (checked) {
          allKeys = allKeys.concat(setCheckedKeys)
        } else {
          remove(allKeys, (n) => setCheckedKeys?.includes(n))
        }
        ref.setCheckedKeys(allKeys, true)
      }
      // 如果取消选中 还需要查看 当前上一级菜单 的所有子是否一个都不存在与
      this.deepDeCheckedParent(ref, checked, checkedNode)
      const { subListBtnOrSubPageKeys } = checkedNode
      subListBtnOrSubPageKeys?.forEach((key) =>
        this.addOrRemoveKeyInSubListCheckedKeys(checked, key))

      // 点击的菜单 需要将菜单下的所有添加进入subListCheckedKeys 取消currentNode
      // 如果是菜单 需要向下延伸触角 每个按钮以及子页面需要被插入
      if (this.isDict(checkedNode.type)) {
        this.currentNode = null
      }

      if (this.isPage(checkedNode.type, checkedNode.pType)) {
        this.handleTreeNodeClick(checkedNode)
      }
      this.$forceUpdate()
    },
    /**
     * 左侧树 被点击
     * 目标只有一个： 将所有的按钮/子页面 放入/删除 subListCheckedKeys
     * */
    handleTreeNodeClick(data) {
      if (data?.type === 1) return
      this.currentNode = cloneDeep(data)
      this.currentNode.checked = !this.currentNodeDisabled
    },
    /**
     * 右侧按钮 checkbox 选中状态变更
     * 从 subListCheckedKeys中去掉或者新增该值
     */
    handleBtnCheckboxChange({ checked, id, businessGroup, pid }) {
      const ref = this.getRef(businessGroup)
      const checkedKeys = ref.getCheckedKeys()
      if (!checkedKeys.includes(pid)) {
        checkedKeys.push(pid)
      }

      this.addOrRemoveKeyInSubListCheckedKeys(checked, id)
      if (!checked) {
        this.$forceUpdate()
        return
      }
      this.currentNode.checked = checked
      checked && ref.setCurrentKey(this.currentNode.id)
      let allKeys = ref.getCheckedKeys()
      const setCheckedKeys = [
        ...this.currentNode.subListPageKeys,
        this.currentNode.id,
      ]
      allKeys = allKeys.concat(setCheckedKeys)
      ref.setCheckedKeys(allKeys, true)
      // 如果取消选中 还需要查看 当前上一级菜单 的所有子是否一个都不存在与
      this.deepDeCheckedParent(ref, checked, this.currentNode)
      this.$forceUpdate()
    },
    /**
     * 点击子页面属性时 事件
     * 当子页面选中时 需 判断父节点是否被选中 如果选中没事 没选中 当前也不能选
     * 当子页面选中时 需 将子页面下的所有subList 添加/删除subListCheckedKeys
     * */
    handleCheckboxChange(subPage) {
      // 针对自身设置
      this.addOrRemoveKeyInSubListCheckedKeys(subPage.checked, subPage.id)
      // 针对 子页面下的按钮进行设置
      subPage.subList.forEach((btnItem) => {
        this.addOrRemoveKeyInSubListCheckedKeys(subPage.checked, btnItem.id)
      })
      this.refreshCurrentNode()
    },
    /**
     * 子页面下的按钮 选中状态变更时的方法
     * 第一：需要判断当前按钮对应的子页面是否被选中 未被选中需要将该子页面选中
     * 第二：需要将该 subListCheckedKeys新增或删除
     */
    handleSubCheckboxChange(subPage, btnItem) {
      if (!this.isBtn(btnItem.type)) return
      this.addOrRemoveKeyInSubListCheckedKeys(btnItem.checked, btnItem.id)
      // 选中的时候 需要着重判断下当前subPage是否选中未选中
      if (btnItem.checked && !subPage.checked) {
        this.addOrRemoveKeyInSubListCheckedKeys(btnItem.checked, subPage.id)
      }
      this.refreshCurrentNode()
    },
    isDict(type) {
      return Number(type) === TYPE_ENUM.DICT
    },
    isBtn(type) {
      return Number(type) === TYPE_ENUM.BTN
    },
    isPage(type, pType) {
      return Number(type) === TYPE_ENUM.PAGE && pType !== TYPE_ENUM.PAGE
    },
    isSubPage(type, pType) {
      return Number(type) === TYPE_ENUM.PAGE && pType === TYPE_ENUM.PAGE
    },
    renderTreeSubList(treedata, pType) {
      let btnOrSubPageList = []
      let dictOrPageList = []
      if (!treedata || !Array.isArray(treedata)) return { btnOrSubPageList, dictOrPageList }
      treedata.forEach((element) => {
        if (this.isDict(element.type) || this.isPage(element.type, pType)) {
          dictOrPageList.push(element.id)
        }
        if (this.isBtn(element.type) || this.isSubPage(element.type, pType)) {
          btnOrSubPageList.push(element.id)
        }
        if (element?.subList) {
          const child = this.renderTreeSubList(element?.subList, element.type)
          btnOrSubPageList = btnOrSubPageList.concat(child.btnOrSubPageList)
          dictOrPageList = dictOrPageList.concat(child.dictOrPageList)
        }
      })
      return {
        btnOrSubPageList,
        dictOrPageList,
      }
    },
    setVisible(son, parent) {
      if (this.isAllRole(son)) {
        parent.visible = VISIBLE_MAPPER.ALL_ROLE
        son.disabled = !!VISIBLE_MAPPER.ALL_ROLE
        this.subListCheckedKeys.push(son.id)
      }
    },
    isAllRole(val) {
      return val.visible === VISIBLE_MAPPER.ALL_ROLE
    },
    // type 资源类型（1目录 2页面 3按钮）
    renderTree(data = [], source = [], parent) {
      const children = []
      data?.forEach((item) => {
        // 将 subListCheckedKeys 中非 子页面 和 按钮的 id去除
        if (
          this.subListCheckedKeys.includes(item.id) &&
          (this.isDict(item.type) || this.isPage(item.type, parent?.type))
        ) {
          remove(this.subListCheckedKeys, (n) => n === item.id)
        }
        // 如果
        if (this.isBtn(item?.type)) {
          item.pType = parent?.type
          item.disabled = false
          this.setVisible(item, parent)
          return
        }
        if (this.isSubPage(item?.type, parent?.type)) {
          item.pType = parent?.type
          item.disabled = false
          item.subList?.forEach((v) => {
            this.setVisible(v, item)
          })

          this.setVisible(item, parent)
          return
        }
        if (item.type === 1 && (!item.subList || item.subList.length === 0)) {
          return
        }
        const newItem = {}
        newItem.id = item.id
        newItem.label = item.name
        newItem.pid = item.pid
        newItem.type = item.type
        newItem.businessGroup = item.businessGroup
        newItem.remark = item.remark
        newItem.pType = parent?.type
        const { btnOrSubPageList, dictOrPageList } = this.renderTreeSubList(
          item.subList,
          item.type,
        )
        newItem.subListBtnOrSubPageKeys = btnOrSubPageList
        newItem.subListPageKeys = dictOrPageList
        newItem.subList = item.subList || []
        newItem.children = Array.isArray(item.subList)
          ? this.renderTree(item.subList, [...source, item.id], item)
          : []

        const visibleItem = newItem.children.find((v) => this.isAllRole(v))
        newItem.visible = item.visible
        newItem.disabled =
          this.isAllRole(item) || !!visibleItem || !this.showCheckbox
        if (newItem.disabled && this.showCheckbox) {
          this.defaultCheckedKeys.push(item.id)
        }
        children.push(newItem)
      })
      return children
    },
    async getResourceByTokenV2() {
      const [webRes, mpRes, privacyRes] = await Promise.all([
        getResourceByTokenV2(RESOURCE_PARAMS[RESOURCE_TYPE.WEB]),
        getResourceByTokenV2(RESOURCE_PARAMS[RESOURCE_TYPE.MP]),
        getResourceByTokenV2(RESOURCE_PARAMS[RESOURCE_TYPE.PRIVACY]),
      ])
      if (webRes?.code === 1) {
        this.web_res = webRes
        this.webTree = this.renderTree(webRes.data)
      }
      if (mpRes?.code === 1) {
        this.mini_program_res = mpRes
        this.mpTree = this.renderTree(mpRes.data)
      }
      if (privacyRes?.code === 1) {
        this.privacy_res = privacyRes
        this.privacyTree = this.renderTree(privacyRes.data)
      }
    },
    /**
     * 编辑时候 需要获取当前模版的所有选中
     * 其中关键是 需要将选中的有些值是半选中的 有些事subList的
     */
    async getRoleDetail() {
      const res = await getPreRoleDetail({
        id: this.id,
        groupName: 'vehicle',
      })
      if (res?.code === 1) {
        this.defaultCheckedKeys = cloneDeep(res?.data?.resourceIdList) || []
        this.subListCheckedKeys = cloneDeep(res.data?.resourceIdList) || []
        if (this.isCopy) return
        this.nameForm = {
          name: res.data.name,
        }
      }
    },
    // 抽屉打开时
    async handleDrawerOpen() {
      this.modeType = this.mode
      // 判断如果是编辑的话 获取默认选中的值
      if (this.id) {
        await this.getRoleDetail()
      }
      // 获取当前所有的节点树
      await this.getResourceByTokenV2()
    },
    handleClose() {
      this.handleDrawerClose()
    },
    handleDrawerClose() {
      this.webTree = []
      this.mpTree = []
      this.privacyTree = []
      this.currentNode = null
      this.filterText = ''
      this.defaultCheckedKeys = []
      this.defaultExpandedKeys = []
      this.subListCheckedKeys = []
      this.subList = []
      this.nameForm = {
        name: '',
      }
      this.$refs.nameForm.clearValidate()
      this.$emit('update:visible', false)
    },
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    handleSubmit() {
      if (this.loading) return
      const webIdList = this.$refs.vehicleWebTree.getCheckedKeys()
      const webHalfIdList = this.$refs.vehicleWebTree.getHalfCheckedKeys()
      const mpIdList = this.$refs.miniProgramTree.getCheckedKeys()
      const mpHalfIdList = this.$refs.miniProgramTree.getHalfCheckedKeys()
      const privacyIdList = this.$refs.vehiclePrivacyTree.getCheckedKeys()
      const privacyHalfIdList = this.$refs.vehiclePrivacyTree.getHalfCheckedKeys()
      if (webIdList.length === 0 && mpIdList.length === 0 && privacyIdList.length === 0) {
        this.$message.warning('请选择需要的权限')
        return
      }
      this.$refs.nameForm.validate(async (valid) => {
        if (!valid) return
        const action = this.isEdit ? editPreRole : addPreRole
        const params = {
          name: this.nameForm.name,
          remark: this.nameForm.remark,
          resourceIdList: [
            ...webIdList,
            ...mpIdList,
            ...webHalfIdList,
            ...mpHalfIdList,
            ...privacyIdList,
            ...privacyHalfIdList,
            ...this.subListCheckedKeys,
          ],
          groupName: 'vehicle',
        }
        if (this.isEdit && !this.id) return
        if (this.isEdit && this.id) {
          params.id = this.id
        }
        this.loading = true
        const res = await action({ ...params })
        this.loading = false
        if (res.code === 1) {
          this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
          this.$emit('refresh')
          this.handleClose()
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep(.el-drawer__header) {
  background-color: #f3f3f4;
  margin-bottom: 0;
  > span {
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
    /* 信息/font-black1 */
    /* 样式描述：强调信息 */
    color: rgba(0, 0, 0, 0.9);
  }
}
.container {
  padding: 8px;
  background-color: #f3f3f4;
  height: calc(100vh - 41px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  &-header {
    background-color: #fff;
    border-radius: 4px;
    &-title {
      padding: 13px 16px;
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
      display: flex;
      align-items: center;
      letter-spacing: 0em;
      /* 信息/font-black1 */
      /* 样式描述：强调信息 */
      color: rgba(0, 0, 0, 0.9);
    }
    &-form {
      padding: 10px 16px;
      font-size: 14px;
    }
  }
  &-section {
    background-color: #fff;
    border-radius: 8px;
    margin-top: 8px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    &-header {
      display: flex;
      padding: 13px 16px;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      border-width: 0px 0px 1px 0px;
      border-style: solid;
      border-color: #e7e8eb;
      &-title {
        color: #000000;
      }
    }
    &-main {
      flex: 1;
      display: flex;
      flex-direction: row;
      overflow: hidden;
      &-aside {
        width: 270px;
        padding: 0 16px;
        overflow-y: auto;
        border-right: 1px solid #e7e8eb;
        &-typetitle {
          line-height: 40px;
          height: 40px;
          border-bottom: 1px solid #e7e8eb;
          /* bodyMD-14px */
          /* 样式描述：默认正文信息 */
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: normal;
          display: flex;
          align-items: center;
          letter-spacing: 0em;
          /* 信息/font-black1 */
          /* 样式描述：强调信息 */
          color: rgba(0, 0, 0, 0.9);
          margin-bottom: 16px;
        }
      }
      &-div {
        padding: 20px;
        flex: 1;
        overflow: auto;
        &-item {
          border-radius: 4px;
          overflow: hidden;
          border: 1px solid #e7e8eb;
          margin-bottom: 20px;
          &-title {
            height: 40px;
            line-height: 40px;
            background-color: #f3f3f4;
            padding-left: 18px;
            > span {
              display: inline-block;
              padding-left: 10px;
            }
          }
          &-ul {
            list-style-type: none;
            display: grid;
            border-top: 1px solid #e7e8eb;
            grid-template-columns: 1fr 1fr;
            padding: 0;
            margin: 0;
            background-color: #e7e8eb;
            gap: 1px;
            box-sizing: border-box;
            > li {
              list-style-type: none;
              padding: 0;
              height: 40px;
              line-height: 40px;
              background-color: #fff;
              margin: 0;
              padding-left: 18px;
              > span {
                display: inline-block;
                padding-left: 10px;
              }
            }
            > li:last-child:nth-child(2n + 1) {
              grid-column: 1 / -1;
            }
          }
        }
      }
    }
  }
  &-footer {
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
::v-deep(.el-checkbox__inner) {
  border: 1px solid rgba(231, 232, 235, 1);
  border-radius: 3px;
  overflow: hidden;
}

::v-deep(.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner) {
  background-color: #DCDDE1;
  border-color: #E7E8EB;
}

::v-deep(.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after) {
  border-color: #FFFFFF;
}

.container-section-main-div-title {
  margin-bottom: 10px;
}
.custom-tree-node {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  align-items: center;
  letter-spacing: 0em;
  /* 信息/font-black1 */
  /* 样式描述：强调信息 */
  color: rgba(0, 0, 0, 0.9);
  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    display: inline-block;
  }
}
.mr-5 {
  margin-right: 5px;
}
.mlt-4 {
  margin-left: 2px !important;
}
.drawer-footer {
  justify-content: flex-end;
  border-top-color: #f3f3f4;
  background: #f3f3f4;
  height: 50px;
}
::v-deep .el-drawer__body {
  background: #f3f3f4;
}
</style>
